import { createStore } from "vuex";
import { initWebsocket } from '@/utils/websocket.js';
import { getRandInt, getPosRandInt } from '@/utils/random.js';

export default createStore({
  state() {
    return {
      setData: null,
      noteData: null,
      dateData: null,
      weekData: null,
      blur: null,
      confirm: null,
      loading: null,
      toast: null,
      user: null,
      wearData: null,
      healthTrend: null,
      healthState: null,
      dysData: null,
      abnormalData: null,
      lateReport: null,
      rankData: null,
      sosData: null,
      sosDetailData: null,
      scrollData: null,
      scoreRadar: null,
      warnData: [],
      mapData: null,
      healthData: null,
      warnUserData: null,
      promptData: null,
      scoreData: null,
      funScoreData: null,
      ajust: null,
      searchData: null,
      currentWarn: null,
      currentWarnType: null,
      floatData: null,
      saveChange: null,
      reportCache: [],
      healthUser: null,
      fullscreen: null,
      heartDate: null,
      weatherData:null,
      groupData:null,
      permission: JSON.parse(localStorage.getItem('userPermission')) || null,
    };
  },
  mutations: {
    setSetData(state, setData) {
      state.setData = setData;
    },
    setNoteData(state, noteData) {
      state.noteData = noteData;
    },
    setDateData(state, dateData) {
      state.dateData = dateData;
    },
    setWeekData(state, weekData) {
      state.weekData = weekData;
    },
    setBlur(state, blur) {
      state.blur = blur ? getRandInt() : getPosRandInt()
    },
    setConfirm(state, confirm) {
      state.confirm = confirm;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setToast(state, toast) {
      state.toast = toast;
    },
    setUser(state, user) {
      state.user = user;
    },
    setHealthData(state, healthData) {
      if (healthData == null) {
        state.searchData = null
      }
      state.healthData = healthData;
    },
    setWearData(state, wearData) {
      state.wearData = wearData;
    },
    setHealthTrend(state, healthTrend) {
      state.healthTrend = healthTrend;
    },
    setHealthState(state, healthState) {
      state.healthState = healthState;
    },
    setDysData(state, dysData) {
      state.dysData = dysData;
    },
    setAbnormalData(state, abnormalData) {
      state.abnormalData = abnormalData;
    },
    setLateReport(state, lateReport) {
      state.lateReport = lateReport;
    },
    setRankData(state, rankData) {
      state.rankData = rankData;
    },
    setSosData(state, sosData) {
      state.sosData = sosData;
    },
    setSosDetailData(state, sosDetailData) {
      state.sosDetailData = sosDetailData;
    },
    setScrollData(state, scrollData) {
      state.scrollData = scrollData;
    },
    setWarnData(state, { name, data }) {
      state.warnData[name] = data;
    },
    setScoreRadar(state, radarData) {
      state.scoreRadar = radarData;
    },
    setMapData(state, mapData) {
      state.mapData = mapData;
    },
    setWarnUserData(state, warnUserData) {
      state.warnUserData = warnUserData;
    },
    setPromptData(state, promptData) {
      state.promptData = promptData;
    },
    setScoreData(state, scoreData) {
      state.scoreData = scoreData;
    },
    setFunScoreData(state, funScoreData) {
      state.funScoreData = funScoreData;
    },
    setAjust(state) {
      state.ajust = Math.random();
    },
    setSearchData(state, searchData) {
      state.searchData = searchData;
    },
    setCurrentWarn(state, currentWarn) {
      state.currentWarn = currentWarn;
    },
    setCurrentWarnType(state, currentWarnType) {
      state.currentWarnType = currentWarnType;
    },
    setFloatData(state, floatData) {
      state.floatData = floatData;
    },
    setSaveChange(state, saveChange) {
      state.saveChange = saveChange;
    },
    setReportCache(state, reportData) {
      if (reportData == null) {
        state.reportCache = [];
        return
      }
      let date = reportData.date;
      let setted = false;
      state.reportCache.forEach(r => {
        if (r.date == date) {
          r.data = reportData.data;
          setted = true
        }
      });
      if (!setted) {
        state.reportCache.push(reportData)
      }
    },
    setHealthUser(state, healthUser) {
      state.healthUser = healthUser;
    },
    setFullScreen(state, fullscreen) {
      state.fullscreen = fullscreen;
    },
    setHeartDate(state, heartDate) {
      state.heartDate = heartDate;
    },
    setWeatherData(state, weatherData) {
      state.weatherData = weatherData;
    },
    setUserGroups(state, groupData) {
      state.groupData = groupData;
    },
    setPermission(state, permission) {
      state.permission = permission;
      localStorage.setItem('userPermission', JSON.stringify(permission));
    },
    clearAllData(state) {
      state.setData = null;
      state.noteData = null;
      state.dateData = null;
      state.weekData = null;
      state.confirm = null;
      state.loading = null;
      state.toast = null;
      state.wearData = null;
      state.healthTrend = null;
      state.healthState = null;
      state.dysData = null;
      state.abnormalData = null;
      state.lateReport = null;
      state.rankData = null;
      state.warnData = [];
      state.mapData = null;
      state.sosDetailData = null;
      state.healthData = null;
      state.warnUserData = null;
      state.promptData = null;
      state.scoreData = null;
      state.funScoreData = null;
      state.ajust = null;
      state.searchData = null;
      state.currentWarn = null;
      state.currentWarnType = null;
      state.floatData = null;
      state.saveChange = null;
      state.healthUser = null;
      state.heartDate = null;
      state.weatherData = null;
      state.groupData = null;
      state.permission = null;
      localStorage.removeItem('userPermission');
    },
    initWebSocket(state) {
      initWebsocket(state.user.token, state.user.orgId)
    }
  },
  //TODO,更改权限判断逻辑
  getters: {
    user(state) {
      return state.user
    },
    pcheck(state) {
      const policy = state.user ? state.user.policy : "";
      return (value) => policy && [].indexOf.call(policy.split(","), value) > -1
    },
    isfullscreen(state) {
      return state.fullscreen && state.fullscreen == "full"
    }
  },
  actions: {
  },
  modules: {}
})